import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

const Image = ({
  className,
  title,
  src,
  placeholderSrc,
  alt,
  inheritedStyles,
  ref,
  ...other
}) => (
  <img
    className={className}
    title={title}
    src={src}
    alt={alt}
    ref={ref}
    {...other}
    onError={event => {
      // eslint-disable-next-line no-param-reassign
      event.target.src = placeholderSrc
    }}
  />
)

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  ref: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
  placeholderSrc: PropTypes.string,
}

Image.defaultProps = {
  ref: null,
  alt: '',
  className: '',
  placeholderSrc: '',
  title: '',
}

export default Image

export const ImageFragment = graphql`
  fragment ImageFragment on ContentfulImage {
    id
    imageTitle
    altText
    imageFile {
      file {
        url
      }
    }
    mobileImageFile {
      file {
        url
      }
    }
  }
`
